import React from "react";
import ImageMaskEditor from "./ImageMaskEditor";

export default function RegenerateModal({
    open,
    onClose,
    base64,
    prompt,
    setPrompt,
    onConfirm,
    setNewBase64
}) {

    const modalStyles = {
        overlay: {
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
            padding: 16, // prevents edge cut
        },
        modal: {
            width: "92%",
            maxWidth: 1100,
            maxHeight: "90vh",          // 🔥 KEY FIX
            background: "#0B0F14",
            borderRadius: 16,
            border: "1px solid #2B3440",
            boxShadow: "0 30px 80px rgba(0,0,0,0.6)",
            display: "flex",            // 🔥 KEY FIX
            flexDirection: "column",
            overflow: "hidden",         // 🔥 KEY FIX
        },
        header: {
            padding: "14px 18px",
            borderBottom: "1px solid #2B3440",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        title: {
            fontSize: 20,
            fontWeight: 700,
            color:'white'
        },
        textarea: {
            width: "100%",
            minHeight: 80,
            background: "#ECFFFF",
            borderRadius: 10,
            border: "2px solid #4EEFEF",
            padding: 14,
            fontSize: 15,
            outline: "none",
            boxSizing: "border-box",
            marginBottom: 14,
        },
        content: {
            padding: 18,
            overflowY: "auto",          // 🔥 SCROLL HERE
            flex: 1,
        },
        editorWrap: {
            background: "#121821",
            borderRadius: 14,
            border: "1px solid #2B3440",
            padding: 12,
        },
        actions: {
            padding: "14px 18px",
            borderTop: "1px solid #2B3440",
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
        },
        cancelBtn: {
            background: "#121821",
            color: "#E5E7EB",
            border: "1px solid #2B3440",
            borderRadius: 10,
            padding: "10px 18px",
            fontWeight: 600,
            cursor: "pointer",
        },
        confirmBtn: {
            background: "linear-gradient(135deg, #FFB347, #FF7A00)",
            color: "#000",
            border: "none",
            borderRadius: 10,
            padding: "10px 22px",
            fontWeight: 800,
            cursor: "pointer",
        },
    };


    const isMobile = window.innerWidth < 768;

    const styles = {
        page: {
            width: "100%",
            minHeight: "100vh",
            background: "#0B0F14",
            padding: isMobile ? "20px 16px" : "32px 40px",
            boxSizing: "border-box",
            fontFamily: "Inter, sans-serif",
            color: "#fff",
        },
        label: { fontSize: 18, fontWeight: 600, marginBottom: 10, textAlign: "left" },
        textarea: {
            width: "100%",
            minHeight: 90,
            background: "#ECFFFF",
            borderRadius: 10,
            border: "2px solid #4EEFEF",
            padding: 16,
            fontSize: 16,
            outline: "none",
            boxSizing: "border-box",
            marginBottom: 6,
        },
        counter: { fontSize: 13, color: "#9CA3AF", marginBottom: 28, textAlign: "left" },
        row: { display: "flex", gap: 32, alignItems: "flex-start", marginBottom: 28, flexDirection: isMobile ? "column" : "row" },
        styleGrid: { display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(auto-fill, minmax(140px, 1fr))", gap: isMobile ? 10 : 12 },
        styleCard: {
            height: 56,
            background: "#121821",
            border: "2px solid #2B3440",
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "0 14px",
            cursor: "pointer",
            fontSize: isMobile ? 13 : 14,
            fontWeight: 600,
            color: "#D1D5DB",
        },
        styleCardActive: {
            background: "#2A1A06",
            borderColor: "#F7941D",
            color: "#F7941D",
        },
        fieldWrapper: { position: "relative", width: "100%", marginBottom: 18 },
        dropdown: {
            width: "100%",
            borderRadius: 14,
            border: "2px solid #2B3440",
            padding: isMobile ? "12px 14px" : "14px 18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: "#0F1419",
            color: "#fff",
            boxSizing: "border-box",
        },
        dropdownMenu: {
            position: "absolute",
            top: 60,
            left: 0,
            width: "100%",
            background: "#0F1419",
            borderRadius: 14,
            border: "2px solid #2B3440",
            maxHeight: isMobile ? 180 : 220,
            overflowY: "auto",
            zIndex: 20,
        },
        dropdownItem: {
            padding: isMobile ? "12px 14px" : "14px 16px",
            fontSize: isMobile ? 14 : 15,
            cursor: "pointer",
            color: "#E5E7EB",
            borderBottom: "1px solid #1F2937",
            textAlign: "left",
        },
        dropdownItemActive: {
            background: "linear-gradient(90deg, #EE4037, #F7941D)",
            color: "#fff",
            fontWeight: 600,
        },
        generateBtn: {
            width: "100%",
            height: 64,
            background: "#F7941D",
            borderRadius: 12,
            border: "none",
            fontSize: 22,
            fontWeight: 700,
            cursor: "pointer",
            color: "#000",
            marginTop: 20,
        },
        resultCard: {
            marginTop: 40,
            background: "#121821",
            borderRadius: 14,
            border: "1px solid #2B3440",
            overflow: "hidden",
        },
        resultHeader: {
            padding: "16px 20px",
            borderBottom: "1px solid #2B3440",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: isMobile ? "wrap" : "nowrap",
            gap: isMobile ? 8 : 0,
        },
        resultTitle: { fontSize: 18, fontWeight: 700 },
        actions: {
            display: "flex",
            gap: 8,
            flexWrap: isMobile ? "wrap" : "nowrap",
            justifyContent: isMobile ? "center" : "flex-end",
        },
        gradientBtn: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "linear-gradient(135deg, #FFB347, #FF7A00)",
            color: "#000",
            border: "none",
            borderRadius: 10,
            padding: isMobile ? "8px 10px" : "10px 16px",
            fontSize: isMobile ? 13 : 14,
            fontWeight: 700,
            cursor: "pointer",
            flex: isMobile ? "1 1 45%" : "initial",
        },
        iconGradient: {
            width: isMobile ? 20 : 28,
            height: isMobile ? 20 : 28,
            borderRadius: 8,
            background: "linear-gradient(135deg, #FFB347, #FF7A00)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#000",
        },
        darkBtn: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "#121821",
            color: "#E5E7EB",
            border: "1px solid #2B3440",
            borderRadius: 10,
            padding: isMobile ? "8px 10px" : "10px 16px",
            fontSize: isMobile ? 13 : 14,
            fontWeight: 600,
            cursor: "pointer",
            flex: isMobile ? "1 1 45%" : "initial",
        },
        imageArea: {
            width: "100%",
            height: 420,
            background: "#0B0F14",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#6B7280",
            fontSize: 16,
        },
        splitImageArea: {
            display: "flex",
            gap: 12,
            height: "520px",   // 🔥 increased
            padding: 12,
        },

        leftPane: {
            flex: 1,
            background: "#111",
            borderRadius: 12,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        },

        rightPane: {
            flex: 1,
            background: "#111",
            borderRadius: 12,
            display: "flex",
            flexDirection: "column",
        },

        paneTitle: {
            fontSize: 13,
            opacity: 0.7,
            marginBottom: 6,
        },

        previewImage: {
            maxWidth: "95%",
            maxHeight: "95%",
            objectFit: "contain",
        },
        editorCanvas: {
            width: "100%",
            height: "450px",   // 🔥 bigger edit area
            borderRadius: 12,
            border: "1px dashed #333",
            cursor: "crosshair",
            background: "#000",
        },

        editorControls: {
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginTop: 8,
        },

        palette: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 8,
        },

        colorDot: {
            width: 22,
            height: 22,
            borderRadius: "50%",
            cursor: "pointer",
        },

    };



    // 🔒 Freeze initial image
    const stableImageRef = React.useRef(
        `data:image/png;base64,${base64}`
    );

    const [localPrompt, setLocalPrompt] = React.useState("");

    if (!open) return null;


    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 999,
            }}
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "92%",
                    maxWidth: 1100,
                    maxHeight: "90vh",
                    background: "#0B0F14",
                    borderRadius: 16,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                {/* Header */}
                <div style={{ padding: 16, borderBottom: "1px solid #2B3440" }}>
                    <strong>Regenerate Image</strong>
                </div>

                <div style={modalStyles.header}>
                    <div style={modalStyles.title}>Regenerate Image</div>
                    <button onClick={onClose} style={modalStyles.cancelBtn}>✕</button>
                </div>

                {/* Content */}
                <div style={{ padding: 18, overflowY: "auto", flex: 1 }}>
                    <textarea
                        value={localPrompt}
                        onChange={(e) => setLocalPrompt(e.target.value)}
                        placeholder="Refine your prompt..."
                        style={modalStyles.textarea}
                    />


                    <ImageMaskEditor
                        image={`data:image/png;base64,${base64}`}
                        onChangeBase64={setNewBase64}
                    />
                </div>

                {/* Footer */}
                <div
                    style={{
                        padding: 16,
                        borderTop: "1px solid #2B3440",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 12,
                    }}
                >
                    <button style={modalStyles.cancelBtn} onClick={onClose}>Cancel</button>
                    <button style={modalStyles.confirmBtn} onClick={() => onConfirm(localPrompt)}>Confirm Regenerate</button>
                </div>
            </div>
        </div>
    );

}
